import { render, staticRenderFns } from "./RegistroServicios.vue?vue&type=template&id=3463c333&scoped=true"
import script from "./RegistroServicios.vue?vue&type=script&lang=js"
export * from "./RegistroServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3463c333",
  null
  
)

export default component.exports